import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from 'store/modals/actions';
import get from 'lodash/get';
import useModalShortcuts from 'Hooks/useModalShortcuts';
import { MODAL_SCHEDULE_DETAIL } from 'store/modals/modals';
import { selectSchedulerDetail } from 'store/Schedule/selectors';
import { resetDetail, saveSchedule } from 'store/Schedule/actions';
import { Accept, Cancel } from 'Common/Components/Button/styled';
import {
  Wrapper, WrapperButtons, Title
} from './styled';

const Header = ({ dataToSave }) => {
  const dispatch = useDispatch();
  const schedulerDetail = useSelector(selectSchedulerDetail);
  const [description, setDescription] = useState(schedulerDetail.value.description);

  useEffect(() => {
    setDescription(schedulerDetail.value.description);
  }, [schedulerDetail]);

  const onClose = () => dispatch(closeModal(MODAL_SCHEDULE_DETAIL));

  const cancel = () => {
    onClose();
    dispatch(resetDetail());
  };

  const onSave = () => {
    const workspacesNames = dataToSave.workspaces.map((ws) => {
      if (ws.name) {
        return ws.name;
      } else {
        return ws;
      }
    });
    dispatch(saveSchedule(
      get(schedulerDetail, 'value.id', 0),
      dataToSave.currentAgent.value.id,
      dataToSave.crontab.name,
      dataToSave.active,
      dataToSave.crontab.expression,
      dataToSave.description,
      dataToSave.tool?.id,
      JSON.stringify(dataToSave.parameters),
      workspacesNames,
      Intl.DateTimeFormat().resolvedOptions().timeZone,
      dataToSave.severityRange
    ));
    onClose();
  };

  useModalShortcuts({
    id: 'scheduler-detail',
    onSave,
    onCancel: cancel,
    saveLabel: 'Save',
    cancelLabel: 'Cancel'
  });

  return (
    <Wrapper>
      <Title children={ description } />
       <WrapperButtons>
          <Cancel onClick={ cancel }>Cancel</Cancel>
          <Accept onClick={ onSave }>Save</Accept>
       </WrapperButtons>
    </Wrapper>
  );
};

export default Header;
